export default "__VITE_ASSET__O88h9_dG__"